import React, { FC, useCallback, useMemo } from 'react';
import Config from 'react-native-config';
import styled from 'styled-components/native';

import { isSIT } from '@webtrader/core/configs';
import { PDPA_URL, PROD_AQ_URL, SIT_AQ_URL, TNC_URL } from '@webtrader/core/constants/experienceDemo';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';

import Text from '@/components/Text';
import { openInAppBrowser } from '@/utils/web';

const IS_SIT = isSIT(Config.ENVIRONMENT);

const mainURL = IS_SIT ? SIT_AQ_URL : PROD_AQ_URL;

const tncUrl = `${mainURL}${TNC_URL}`;

const pdpaUrl = `${mainURL}${PDPA_URL}`;

const ConsentText: FC = () => {
  const { t } = useTranslation();

  const openTncUrl = useCallback(() => {
    openInAppBrowser(tncUrl);
  }, []);

  const openPolicyUrl = useCallback(() => {
    openInAppBrowser(pdpaUrl);
  }, []);

  const tncUrlLabel = useMemo(() => {
    return <StyledLinkText onPress={openTncUrl}>{t('Terms and Conditions')}</StyledLinkText>;
  }, [openTncUrl, t]);

  const pdpaUrlLabel = useMemo(() => {
    return <StyledLinkText onPress={openPolicyUrl}>{t('Data Privacy Policy')}</StyledLinkText>;
  }, [openPolicyUrl, t]);

  const consentTextLabel = useMemo(() => {
    return t(
      "I consent to providing my email address to access the AQX Trader Demo Platform and agree to Aquariux Pte Ltd's"
    );
  }, [t]);

  return (
    <StyledCheckBoxLabel>
      {consentTextLabel} {tncUrlLabel} {t('and')} {pdpaUrlLabel}
    </StyledCheckBoxLabel>
  );
};

export default ConsentText;

const StyledCheckBoxLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.text[1]};
  line-height: ${dynamicSize.convertSize(20)}px;
  flex-wrap: wrap;
  flex-direction: row;
  flex-shrink: 1;
  font-size: ${dynamicSize.convertSize(13)}px;
`;

const StyledLinkText = styled(Text)`
  color: ${({ theme }) => theme.colors.text[0]};
  font-weight: bold;
  font-size: ${dynamicSize.convertSize(13)}px;
`;
